export default __webpack_public_path__ + "static/media/reset-password.8251d226.svg";